/*
      ___           ___
     /\  \         /\  \
    /::\  \       /::\  \
   /:/\:\  \     /:/\ \  \
  /::\ \:\  \   _\:\ \ \  \
 /:/\:\ \:\__\ /\ \:\ \ \__\
 \/_|::\/:/  / \:\ \:\ \/__/
    |:|::/  /   \:\ \:\__\
    |:|\/__/     \:\/:/  /
    |:|  |        \::/  /
     \|__|         \/__/

    Developed by Ralph Shippam - 2019.
*/

import { NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RSDialogComponent } from './rsdialog.component';
import { RSBottomSheetComponent } from './rsbottomsheet.component';
import { RSDialogService } from './rsdialog.service';

import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormsModule} from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatExpansionModule,
        MatIconModule,
        MatListModule,
        MatBottomSheetModule,
        MatInputModule,
        MatFormFieldModule,
        FormsModule
    ],
  providers: [
      RSDialogService
  ],
  exports: [],
  declarations: [
      RSDialogComponent,
      RSBottomSheetComponent
  ]
})
export class RSDialogModule {}
